import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './login.module.css'
import { AVNLight } from '../../img'
import { Button, Input } from '../../ui'

const Login = ({ login, password, isShowPassword, handleLogin, isLoader, change, changeShowPassword }) => {
	const { t } = useTranslation()

	return (
		<>
			<div className={styles.br} />
			<div className={styles.auth} style={{ backgroundImage: 'url("/bt/img/background.svg")' }}>
				<div className={styles.auth__left}>
					<img className={styles.auth__avn} src='/bt/img/AVN_new_SVG.svg' alt='avn' />
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							height: 'calc(100vh - 130px)',
							justifyContent: 'center'
						}}
					>
						<div className={styles.auth__left__container}>
							<h2 className={styles.auth__title}>
								Добро пожаловать <br /> в информационную систему АВН
							</h2>
							<div>
								<h2 className={styles.auth__title} style={{ marginTop: '16px' }}>
									Единое окно
								</h2>
							</div>
							<form className={styles.auth__form}>
									<div className={styles.auth__form__container}>
										<Input
											id='login'
											name='login'
											label='Логин'
											placeholder='Введите логин'
											value={login}
											onChange={change}
											style={{ width: '94%' }}
										/>
										<i className={`fa-solid fa-user ${styles.auth__form__container__icon}`} />
									</div>
									<div className={styles.auth__form__container}>
										<Input
											id='password'
											label='Пароль'
											name='password'
											type={isShowPassword ? 'text' : 'password'}
											placeholder='Введите пароль'
											value={password}
											onChange={change}
											style={{ width: '94%' }}
										/>
										{isShowPassword ? (
											<i
												className={`fa-solid fa-eye-slash ${styles.auth__form__container__icon}`}
												style={{ cursor: 'pointer', right: 12 }}
												onClick={changeShowPassword}
											/>
										) : (
											<i
												onClick={changeShowPassword}
												style={{ cursor: 'pointer' }}
												className={`fa-solid fa-eye ${styles.auth__form__container__icon}`}
											/>
										)}
									</div>
									<Button
										loader={isLoader}
										value='Войти'
										style={{ borderRadius: 6, width: '100%' }}
										onClick={handleLogin}
									/>
							</form>
						</div>
					</div>
				</div>

				<div className={styles.auth__right}>
					<img src={AVNLight} alt='avn' />
					{/* <h3>Простые решения для сложных задач</h3> */}
				</div>
			</div>
		</>
	)
}

export default Login
